import { FlightCard } from '@/src/types/flight'
import { useCallback, useState } from 'react'

export const useRTSolutionCardStatesManager = (samePriceCards: FlightCard[]) => {
    const [expandSamePriceCard, setExpandSamePriceCard] = useState(false)

    const handleExpandSamePriceCard = useCallback(() => {
        setExpandSamePriceCard(!expandSamePriceCard)
    }, [expandSamePriceCard])

    const mainCard = samePriceCards[0]
    const extraCards = samePriceCards.slice(1)
    return { expandSamePriceCard, handleExpandSamePriceCard, mainCard, extraCards }
}
